import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const bonos = [{
  id: 1,
  icon: '🎯',
  title: 'BONO 1 — "Banco de 100 WODs Listos para Usar"',
  value: '$12.000',
  desc: '100 WODs organizados por modalidad, intensidad y nivel. Cada uno con versión Rx, Scaled y Beginner. Listo para poner en el pizarrón hoy mismo.'
}, {
  id: 2,
  icon: '📋',
  title: 'BONO 2 — "Planillas de Evaluación de Alumnos"',
  value: '$9.000',
  desc: '30 fichas y planillas listas para imprimir: anamnesis, evaluación funcional, registro de 1RM, seguimiento mensual, reunión de progreso y más.'
}, {
  id: 3,
  icon: '🥗',
  title: 'BONO 3 — "Guía de Nutrición para Atletas de Crossfit"',
  value: '$8.000',
  desc: 'Timing nutricional, macros por objetivo, planes de alimentación completos y guía de suplementación basada en evidencia. Para que le puedas dar respuesta a tus alumnos.'
}, {
  id: 4,
  icon: '🔥',
  title: 'BONO 4 — "Protocolo de Calentamiento Específico"',
  value: '$10.000',
  desc: '30 protocolos de calentamiento organizados por movimiento y tipo de WOD. Pre-Snatch, Pre-Deadlift, Pre-HSPU, Pre-AMRAP y más. Listos para aplicar en cada clase.'
}, {
  id: 5,
  icon: '💪',
  title: 'BONO 5 — "Banco de 200 Ejercicios de Movilidad"',
  value: '$9.000',
  desc: '200 ejercicios organizados por zona corporal: tobillo, rodilla, cadera, columna, hombro y muñeca. Con protocolos completos para pre-entreno, post-entreno y día de descanso.'
}, {
  id: 6,
  icon: '🏆',
  title: 'BONO 6 — "Guía de Competencias y Testeos"',
  value: '$8.000',
  desc: 'Sistema completo para preparar a tus alumnos para competir + protocolo de testeos y benchmarks para medir el progreso real del box. Incluye el protocolo del CrossFit Open.'
}];
export function BonosSlider() {
  const [openId, setOpenId] = useState<number | null>(1);
  return <section className="py-12 md:py-20 px-4 bg-cf-dark border-t border-white/5" data-id="element-20">
      <div className="max-w-3xl mx-auto" data-id="element-21">
        <div className="text-center mb-8 md:mb-12" data-id="element-22">
          <h2 className="font-bebas text-3xl md:text-5xl text-white tracking-tight mb-2" data-id="element-23">
            INCLUIDOS GRATIS — 6 BONOS ESTRATÉGICOS
          </h2>
        </div>

        <div className="space-y-3 mb-8" data-id="element-24">
          {bonos.map(bono => {
          const isOpen = openId === bono.id;
          return <div key={bono.id} className={`bg-cf-card border rounded-lg overflow-hidden transition-colors ${isOpen ? 'border-cf-red' : 'border-white/10'}`} data-id="element-25">
                <button onClick={() => setOpenId(isOpen ? null : bono.id)} className="w-full px-4 md:px-6 py-4 md:py-5 text-left flex justify-between items-center hover:bg-white/5 transition-colors gap-3" data-id="element-26">
                  <div className="flex items-center gap-3 md:gap-4 min-w-0 flex-1" data-id="element-27">
                    <span className="text-2xl md:text-3xl shrink-0" data-id="element-28">
                      {bono.icon}
                    </span>
                    <span className="font-bebas text-base md:text-xl text-white tracking-wide leading-tight" data-id="element-29">
                      {bono.title}
                    </span>
                  </div>
                  <div className="flex items-center gap-2 shrink-0" data-id="element-30">
                    <span className="hidden sm:inline-block bg-cf-red text-white font-bold px-2 py-1 rounded text-xs tracking-wider" data-id="element-31">
                      GRATIS
                    </span>
                    <ChevronDown className={`w-5 h-5 text-cf-red transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`} data-id="element-32" />
                  </div>
                </button>
                <AnimatePresence initial={false} data-id="element-33">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3
              }} data-id="element-34">
                      <div className="px-4 md:px-6 pb-5 md:pb-6 border-t border-white/10 pt-4" data-id="element-35">
                        <div className="bg-cf-red text-white font-bold px-3 py-1.5 rounded-full text-xs tracking-wider mb-4 inline-block" data-id="element-36">
                          Valor: {bono.value} — GRATIS
                        </div>
                        <p className="text-gray-300 text-sm md:text-base leading-relaxed" data-id="element-37">
                          {bono.desc}
                        </p>
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>

        <div className="text-center bg-cf-darker border border-cf-gold/50 p-5 md:p-6 rounded-lg" data-id="element-38">
          <p className="font-bebas text-2xl md:text-4xl text-white leading-tight" data-id="element-39">
            VALOR TOTAL DE LOS 6 BONOS:{' '}
            <span className="text-cf-red line-through opacity-70" data-id="element-40">$56.000</span>{' '}
            <span className="text-cf-gold" data-id="element-41">GRATIS</span>
          </p>
          <p className="text-gray-400 mt-2 text-sm md:text-base" data-id="element-42">
            Incluidos siempre en ambas ofertas
          </p>
        </div>
      </div>
    </section>;
}